<script lang="ts">
  import { TextCopy, TextInfo } from '$lib/components/text';
  import type { NatureDto, CompanySizeDto } from '$lib/features/bff/sdk';
  import { formatCurrency, formatNature } from '$lib/features/format';

  /** Required */
  export let equity: number;
  /** Required */
  export let jurisdiction: string;
  /** Required */
  export let name: string;
  /** Required */
  export let nature: NatureDto;
  /** Required */
  export let size: CompanySizeDto;
</script>

<div class="flex flex-wrap gap-x-8 gap-y-6">
  <!-- Name -->
  <TextInfo icon="file-badge" label="Razão Social" value={name} copiable={true} />

  <!-- Size -->
  <TextInfo icon="align-end-horizontal" label="Porte" value={size.text} copiable={true} />

  <!-- Equity -->
  <TextInfo
    icon="candlestick-chart"
    label="Capital Social"
    value={formatCurrency(equity || 0)}
    copiable={true}
    onCopy={() => String(equity)}
  />

  {#if jurisdiction}
    <!-- Jurisdiction -->
    <TextInfo icon="globe" label="Ente Federativo" value={jurisdiction || '-'} copiable={true} />
  {/if}

  <!-- Nature -->
  <TextInfo icon="scale" label="Natureza Jurídica">
    <TextCopy value={formatNature(nature.id)} onCopy={() => String(nature.id)} />
    <span> - </span>
    <TextCopy value={nature.text} />
  </TextInfo>
</div>
